export default ({ request }) => ({
  /**
   * 创建修改简历
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_SAVE (data = {}) {
    // 接口请求
    return request({
      url: 'resume',
      method: 'POST',
      data
    })
  },
  /**
   * 手机端创建修改教育经历
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_EDU_SAVE (data = {}) {
    // 接口请求
    return request({
      url: 'resume/educationhistory',
      method: 'POST',
      data
    })
  },
  /**
   * 删除工作经历
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_EDU_DEL (params ) {
    // 接口请求/resume/educationhistory/delete
    // 删除
    return request({
      url: 'resume/educationhistory/delete',
      method: 'POST',
      data:params
    })
  },
  /**
   * 获取简历
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_GET (params = {}) {
    // 接口请求
    return request({
      url: 'resume',
      method: 'GET',
      params
    })
  },
  /**
   * 获取简历
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_ENCLOSURE_SAVE (params = {}) {
    // 接口请求
    return request({
      url: 'resume/enclosure',
      method: 'POST',
      data:params
    })
  },
  /**
   * 上传文件
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_File_SAVE (params = {}) {
    // 接口请求
    return request({
      url: 'file',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data:params
    })
  },
  /**
   *  获取文件
   * @param data
   * @returns {*}
   * @constructor
   */
  RESUME_FILE_GET (params = {}) {
    // 接口请求
    return request({
      url: 'file',
      method: 'GET',
      params
    })
  }
})

